<template>
  <BaseModal modal-content-class="bonus_modal midnight">
    <div class="content">
      <BaseImage :src="bundleDiscountImage" image-class="bonus_img" alt="Bundle Discount" />

      <h2>{{ $_translations.value[titleText] }}</h2>

      <div class="bonus_time">
        <h2>{{ $_translations.value[subtitleText] }}</h2>

        <p>
          {{ $_translations.value.modal_bonus_bundle_discount_duration_pt1 }}
          {{ duration }}
          {{ $_translations.value.modal_bonus_bundle_discount_duration_pt2 }}
        </p>

        <div class="timer_box">
          <BaseCountdownTimer
            :end-date="endDate"
            el-class="bonus_timer"
            timer-format="hh:mm:ss"
          />
        </div>
      </div>

      <div class="text">
        <p>
          {{ $_translations.value[description.pt1] }}
          {{ timeRange }}
          {{ $_translations.value[description.pt2] }}
        </p>

        <p>{{ $_translations.value[description.pt3] }}</p>
      </div>

      <BaseButton @click:button="$emit('redirect:storePage')">
        {{ $_translations.value.modal_bonus_bundle_discount_button_proceed }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import { computed } from 'vue';
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseCountdownTimer from '@/components/timer/BaseCountdownTimer.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import { getTimeDuration, getTimeRange } from '@/helpers/time.js';
import { bundleDiscountImage } from '@/constants/image.js';

defineEmits(['redirect:storePage']);

const props = defineProps({
  startDate: {
    type: [String, Number, Date],
    default: '',
  },
  endDate: {
    type: [String, Number, Date],
    default: '',
  },
  multiplier: {
    type: Number,
    default: 0,
  },
});

const titleText = computed(() => `modal_bonus_bundle_discount_title_x${ props.multiplier }`);

const subtitleText = computed(() => `modal_bonus_bundle_discount_subtitle_x${ props.multiplier }`);

const duration = computed(() => getTimeDuration(props.startDate, props.endDate));

const timeRange = computed(() => getTimeRange(props.startDate, props.endDate));

const description = computed(() => ({
  pt1: 'modal_bonus_bundle_discount_description_pt1',
  pt2: `modal_bonus_bundle_discount_description_pt2_x${ props.multiplier }`,
  pt3: 'modal_bonus_bundle_discount_description_pt3',
}));
</script>
